import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface Agency {
	agenNm: string;
	agenAddr: string;
	agenTel: string;
	agenFax: string;
}

const key = "useAgencyInfo";
/** ```
 * 대리점 정보 가져오기
 *   `/api/info/agency/${agentCd}`
 * parameter
 *  agentCd 대리점코드
 * ```*/
const getPath = (agenCd: string): string => `${publicRuntimeConfig.ENV_PORTAL_API_URL}/pkg/goods/agency/${agenCd}`;

/** ```
 * 대리점 정보 가져오기
 *   `/api/info/agency/${agentCd}`
 * parameter
 *  agentCd 대리점코드
 * ```*/
const useAgencyInfo = (agentCd: string, options?: Partial<UseQueryOptions<Response<Agency>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(agentCd)],
		queryFn: () => useConfigureAxios({url: getPath(agentCd)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		placeholderData: {
			body: {
				agenNm: "",
				agenAddr: "",
				agenTel: "",
				agenFax: "",
			},
		},
		...options,
	});

export default useAgencyInfo;
export {getPath};
export type {Agency};
